import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { CONTACT, FOOTER_SERVICE_LINKS, NAV_LINKS } from "../data/content";

const SOCIALS = [
  { icon: Facebook, label: "Facebook" },
  { icon: Twitter, label: "Twitter" },
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Instagram, label: "Instagram" },
];

export const Footer = () => (
  <footer className="border-t border-border bg-section" data-testid="footer">
    <div className="container-x grid gap-12 py-16 md:grid-cols-12">
      <div className="md:col-span-4">
        <img
          src="/skyroute-logo.png"
          alt="SkyRoute Freights Pvt Ltd"
          className="h-14 w-auto object-contain"
        />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">
          India's trusted global freight forwarding partner — connecting your
          business to the world with speed, precision, and care.
        </p>
        <div className="mt-6 flex gap-3">
          {SOCIALS.map(({ icon: Icon, label }) => (
            <a
              key={label}
              href="#"
              aria-label={label}
              data-testid={`footer-social-${label.toLowerCase()}`}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition-colors hover:bg-brand hover:text-white"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Our Services</p>
        <ul className="mt-5 space-y-3">
          {FOOTER_SERVICE_LINKS.map((s) => (
            <li key={s}>
              <Link
                to="/services"
                data-testid={`footer-link-service-${s.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className="text-sm text-muted-foreground transition-colors hover:text-brand"
              >
                {s}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-2">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Quick Links</p>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="text-sm text-muted-foreground transition-colors hover:text-brand"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Contact Us</p>
        <ul className="mt-5 space-y-4 text-sm text-muted-foreground">
          <li className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
            {CONTACT.footerAddress}
          </li>
          <li>
            <a
              href={CONTACT.phoneHref}
              data-testid="footer-contact-phone"
              className="flex items-center gap-3 transition-colors hover:text-brand"
            >
              <Phone className="h-4 w-4 shrink-0 text-brand" />
              {CONTACT.phone}
            </a>
          </li>
          <li>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="footer-contact-email"
              className="flex items-center gap-3 transition-colors hover:text-brand"
            >
              <Mail className="h-4 w-4 shrink-0 text-brand" />
              {CONTACT.email}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-border">
      <div className="container-x flex flex-col items-start justify-between gap-3 py-6 text-xs text-muted-foreground md:flex-row md:items-center">
        <p>© {new Date().getFullYear()} SkyRoute Freights Pvt Ltd. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#" className="transition-colors hover:text-brand">Privacy Policy</a>
          <a href="#" className="transition-colors hover:text-brand">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);
